import { useQuery, useConvexAuth } from 'convex/react'
import { api } from '@backend/_generated/api'

/**
 * Returns whether the logged-in user is a platform admin (cross-org superuser).
 * Returns `false` while loading or when unauthenticated.
 */
export function useIsPlatformAdmin(): boolean {
  const { isAuthenticated } = useConvexAuth()
  const profile = useQuery(
    api.profile.getMyProfile,
    isAuthenticated ? {} : 'skip',
  )
  return profile?.isPlatformAdmin ?? false
}
